'use client';

import { useCallback } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'next-i18next';
import { Modal } from '@components/common/Modal/Modal';
import { useMissionControlContext } from '@hooks/features/useMissionControlContext';
import { useReduxUser } from '@hooks/common/useAuthClient/useReduxUser';
import GeminiVoiceWidget from '@components/features/voice/GeminiVoiceWidget';

export const BestieVoiceModal = NiceModal.create(() => {
  const modal = useModal();
  const { t } = useTranslation('common');
  const { currentContext } = useMissionControlContext();
  const { headerInfo } = useReduxUser();
  const typedHeaderInfo = headerInfo;
  const isAuthenticated = !!typedHeaderInfo?.userId;
  const isCandidate = currentContext === 'candidate';
  const firstName = isAuthenticated ? (typedHeaderInfo?.name?.split(' ')[0] ?? '') : '';

  const firstMessageKey = isCandidate
    ? (isAuthenticated ? 'inbound.greeting.candidat.logged' : 'inbound.greeting.candidat.not_logged')
    : (isAuthenticated ? 'inbound.greeting.employer.logged' : 'inbound.greeting.employer.not_logged');

  const firstMessage = t(firstMessageKey, { first_name: firstName });

  const closeModal = useCallback(() => {
    void modal.hide();
    modal.remove();
  }, [modal]);

  return (
    <Modal
      isOpen={modal.visible}
      onClose={closeModal}
      backdropClickDisabled
      size="sm"
      className="!max-w-sm !rounded-3xl"
      body={<GeminiVoiceWidget firstMessage={firstMessage} onClose={closeModal} />}
    />
  );
});
